export default {"src":"/_next/static/media/form-editor-automated-mail.12f4bd11.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};